
/**
* @desc checkbox filter directive for filtering stories and tasks
* @example <checkbox-filter filter="" schema-method="" argument=""></checkbox-filter>
*/

import template from './checkboxFilter.html';
import controller from './CheckboxFilterController';


function checkboxFilter() {
  return {
    restrict: 'E',
    scope: {
      filter: '=',
      schemaMethod: '@',
      argument: '@'
    },
    template,
    controller: 'CheckboxFilterController'
  };
}

export default function (ngModule) {
  ngModule.directive('checkboxFilter', [
    checkboxFilter
  ]);
  controller(ngModule);
}
